import { ozowBankMapping, payretailersBankMapping } from './const'
import { processingProviderName } from '../../libs/processingProvider'
import { WithdrawalEdit } from './withdrawals/edit'

export function mappingBankValue(
  key: string,
  value: string,
  withdrawal: WithdrawalEdit,
): string {
  if (key === 'bankGroupID') {
    return ozowBankMapping[value.toUpperCase()] ?? value
  }

  if (key === 'bank' || key === 'bankName') {
    if (
      withdrawal.processingProvider === processingProviderName.payretailers()
    ) {
      return `${payretailersBankMapping[value] ?? value} (${value})`
    }
  }
  return value
}

export function mappingBankValueWithFieldDataType(
  value: string,
  withdrawal: WithdrawalEdit,
): string {
  if (!value) return value

  // нормализуем код: убираем ведущие нули
  const normalizedValue = value.replace(/^0+/, '')

  switch (withdrawal.processingProvider) {
    case 'ozow':
      return `${ozowBankMapping[value] ?? value} (${value})`
    case 'payretailers':
      return `${payretailersBankMapping[value] ?? value} (${value})`
    default:
      return value
  }
}
